import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const UtmSelectView = observer(({ store, isDisabled = false, clearable = false }) => {
    return (<>
      <Select
            sm={10}
            className="react-select-container"
            classNamePrefix="react-select"
            options={store?.options()}
            id="selected"
            value={store?.selected}
            onInputChange={(data) => store?.search(data)}
            onChange={(data) => store?.select(data)}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.uuid}
            placeholder="Select"
            isDisabled={isDisabled}
            isClearable = {clearable}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensure dropdown stays on top
              control: (base, state) => ({
                ...base
              }),
              menu: (base) => ({
                ...base,
                borderRadius: "6px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                fontSize: "15px",
              }),
              option: (base, state) => ({
                ...base,
                fontSize: "15px",
                padding: "5px 5px",
                backgroundColor: state.isSelected ? "rgb(38, 132, 255)" : "white",
                color: state.isSelected ? "white" : "#3e4676",
                textAlign: "center",
                "&:hover": {
                  backgroundColor: state.isSelected ? "rgb(38, 132, 255)" : "rgb(222, 235, 255)"
                },
                cursor:"pointer"
              })
            }}
          />
      </>
    );
});

export default UtmSelectView;
